import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Landing from "@/pages/Landing";
import LegalLayout from "@/pages/LegalLayout";
import ProductDetail from "@/pages/ProductDetail";
import Danke from "@/pages/Danke";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/impressum" element={<LegalLayout pageKey="impressum" />} />
            <Route path="/datenschutz" element={<LegalLayout pageKey="datenschutz" />} />
            <Route path="/agb" element={<LegalLayout pageKey="agb" />} />
            <Route path="/datenschutz-email-signatur" element={<LegalLayout pageKey="datenschutzEmail" />} />
            <Route path="/aufsteller/:slug" element={<ProductDetail />} />
            <Route path="/danke" element={<Danke />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
